export default theme => ({
  page_header_bar: {
    maxWidth: 1500,
    margin: "auto",
    padding: 0,
    boxShadow: "none",
    backgroundColor: "transparent",
    paddingBottom: 20,
    paddingTop: 20,
  },
  page_header_bar_mainTitle: {
    marginTop: theme.spacing(4),
    paddingTop: 0,
  },
  page_header_bar_container: {
    padding: "0px !important",
  },
});
